import { DateTime } from 'luxon';

import { DateRangeRequest } from '@core/api/multi-site-dashboard/multi-site-dashboard.models';

import { VehicleSocSummaryRange } from '../../enums/vehicle-soc-summary-range.enum';

const ISO_DATE_FORMAT = 'yyyy-MM-dd';

// Builds the inclusive [start, end] window for the vehicle-state-of-charge-summary endpoint: `end` is
// today and `start` is `range - 1` days earlier, so the table spans exactly `range` calendar days.
export const buildVehicleSocSummaryDateRange = (range: VehicleSocSummaryRange): DateRangeRequest => {
  const end = DateTime.now().startOf('day');
  const start = end.minus({ days: range - 1 });

  return {
    start: start.toFormat(ISO_DATE_FORMAT),
    end: end.toFormat(ISO_DATE_FORMAT),
  };
};
